import { useState } from "react";

function ChemistryToolkit({ language, onInsertSymbol }) {
  const [showTools, setShowTools] = useState(false);

  const symbolButtonStyle = {
    fontSize: "22px",
    padding: "10px 14px",
    margin: "5px",
    minWidth: "58px",
    borderRadius: "10px",
    cursor: "pointer",
    border: "1px solid #d1d5db",
    background: "white",
  };

  const sectionHeadingStyle = {
    marginTop: "25px",
    marginBottom: "8px",
  };

  const renderButtons = (symbols) =>
    symbols.map((symbol) => (
      <button
        key={symbol}
        type="button"
        style={symbolButtonStyle}
        onClick={() => onInsertSymbol(symbol)}
      >
        {symbol}
      </button>
    ));

  return (
    <div
      style={{
        marginTop: "20px",
        background: "white",
        padding: "15px",
        borderRadius: "10px",
        marginBottom: "15px",
      }}
    >
      <button
        type="button"
        onClick={() => setShowTools((previousValue) => !previousValue)}
        style={{
          fontSize: "18px",
          padding: "12px",
          borderRadius: "10px",
          cursor: "pointer",
          marginBottom: "15px",
          background: "#2563eb",
          color: "white",
          border: "none",
        }}
      >
        {language === "af"
          ? "🧪 Wetenskaphulpmiddels"
          : "🧪 Science Toolkit"}
      </button>

      {showTools && (
        <>
          <h4 style={sectionHeadingStyle}>
            {language === "af"
              ? "⚛️ Chemiese simbole"
              : "⚛️ Chemical symbols"}
          </h4>
          {renderButtons(["H⁺", "OH⁻", "Na⁺", "Cl⁻", "CO₂", "H₂O", "NH₃", "H₂SO₄"])}

          <h4 style={sectionHeadingStyle}>
            {language === "af"
              ? "📏 Wetenskaplike notasie"
              : "📏 Scientific notation"}
          </h4>
          {renderButtons([" ×10⁻¹", " ×10⁻²", " ×10⁻³", " ×10⁻⁴", " ×10⁻⁵"])}

          <h4 style={sectionHeadingStyle}>
            {language === "af" ? "🔼 Boskrifte" : "🔼 Superscripts"}
          </h4>
          {renderButtons(["⁰", "¹", "²", "³", "⁴", "⁵", "⁶", "⁷", "⁸", "⁹", "⁺", "⁻"])}

          <h4 style={sectionHeadingStyle}>
            {language === "af" ? "🔽 Onderskrifte" : "🔽 Subscripts"}
          </h4>
          {renderButtons(["₀", "₁", "₂", "₃", "₄", "₅", "₆", "₇", "₈", "₉"])}

          <h4 style={sectionHeadingStyle}>
            {language === "af"
              ? "🔁 Reaksies en toestande"
              : "🔁 Reactions and states"}
          </h4>
          {renderButtons([" → ", " ⇌ ", "Δ", "°", "·", "(s)", "(ℓ)", "(g)", "(aq)"])}

          <h4 style={sectionHeadingStyle}>
            {language === "af"
              ? "📐 Hakies en eenhede"
              : "📐 Brackets and units"}
          </h4>
          {renderButtons(["[", "]", "mol", "dm³", "cm³", "g·mol⁻¹", "mol·dm⁻³", "mol·s⁻¹"])}
        </>
      )}
    </div>
  );
}

export default ChemistryToolkit;
